import { createIcon } from '@chakra-ui/react'

export const Plus = createIcon({
  displayName: 'Plus',
  viewBox: '0 0 14 14',
  d: 'M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z',
})
